module.exports = __webpack_public_path__ + "static/media/(V)_MG_6182_-_Joias_Contenporaneas.f01ade9e.jpg";